module.exports = __webpack_public_path__ + "img/banner-roche.20afa940.png";